"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.giftShape = exports.InvitationItemShape = exports.InvitationItemAddressShape = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _product = require("./product.shape");

var InvitationItemAddressShape = _propTypes.default.shape({
  address_line_1: _propTypes.default.string,
  address_line_2: _propTypes.default.string,
  city: _propTypes.default.string,
  country_id: _propTypes.default.number,
  state: _propTypes.default.string,
  zip: _propTypes.default.string
});

exports.InvitationItemAddressShape = InvitationItemAddressShape;

var InvitationItemShape = _propTypes.default.shape({
  type_id: _propTypes.default.number.isRequired,
  chars_limit: _propTypes.default.number.isRequired,
  image: _propTypes.default.string.isRequired,
  type: _propTypes.default.string.isRequired,
  return_address: _propTypes.default.oneOf([null, InvitationItemAddressShape]).isRequired,
  country_address: _propTypes.default.oneOf([null, InvitationItemAddressShape]).isRequired
});

exports.InvitationItemShape = InvitationItemShape;

var giftShape = _propTypes.default.shape({
  status_label: _propTypes.default.string,
  contact_id: _propTypes.default.number.isRequired,
  updated_at: _propTypes.default.string,
  invitation_type: _propTypes.default.string,
  product_id: _propTypes.default.number,
  id: _propTypes.default.number.isRequired,
  status_id: _propTypes.default.number.isRequired,
  campaign_id: _propTypes.default.number.isRequired,
  number_to_propose: _propTypes.default.number.isRequired,
  message: _propTypes.default.string,
  can_be_exchanged: _propTypes.default.bool,
  sent_as: _propTypes.default.shape({
    avatar: _propTypes.default.string,
    email: _propTypes.default.string,
    full_name: _propTypes.default.string,
    id: _propTypes.default.number
  }),
  // eslint-disable-next-line react/forbid-prop-types
  prospect: _propTypes.default.object,
  proposed_products: _propTypes.default.arrayOf(_product.productShape),
  gift_invitation_item: _propTypes.default.oneOf([null, InvitationItemShape]).isRequired
});

exports.giftShape = giftShape;